/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as RepoStrongRef from "../../../com/atproto/repo/strongRef.defs.js";

const $nsid = "place.stream.live.teleport";

export { $nsid };

/** Record defining a 'teleport', that is active during a certain time. */
type Main = { $type: "place.stream.live.teleport";

  /**
   * The DID of the streamer to teleport to.
   */
  "streamer":l.DidString;

  /**
   * The time the teleport becomes active.
   */
  "startsAt":l.DatetimeString;

  /**
   * The source livestream this teleport is sending viewers away from. When the teleport fires, this is the livestream that gets ended (the same update place.stream.live.stopLivestream performs), so the source streamer returns to pre-live. Teleports without an origin livestream are treated as a no-op.
   */
  "livestream"?:RepoStrongRef.Main;

  /**
   * The time limit in seconds for the teleport. If not set, the teleport is permanent. Must be at least 60 seconds, and no more than 32,400 seconds (9 hours).
   */
  "durationSeconds"?:number };

export type { Main };

/** Record defining a 'teleport', that is active during a certain time. */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"streamer":/*#__PURE__*/ l.string({"format":"did"}),"startsAt":/*#__PURE__*/ l.string({"format":"datetime"}),"livestream":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any)),"durationSeconds":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer({"minimum":60,"maximum":32400}))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
